import { useState } from "react";
import {
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { Categories, Category } from "models/Checklist";
import { useOrderContext } from "context/OrderContext";
import { useCreateChecklistMutation } from "app/api/orders";
import LargeDialog from "components/LargeDialog";
import CancelIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";

type AddChecklistDialogProps = { onClose: () => void };

const AddChecklistDialog: React.FC<AddChecklistDialogProps> = (props) => {
  const { onClose } = props;
  const order = useOrderContext();
  const [createChecklist, { isLoading }] = useCreateChecklistMutation();

  const [roomName, setRoomName] = useState<string>("");
  const [categories, setCategories] = useState<Category[]>([]);

  return (
    <LargeDialog
      title="Skapa ny checklista"
      onClose={onClose}
      onSubmit={(e) => {
        e.preventDefault();
        createChecklist({ orderId: order.ordernr, roomName, categories })
          .unwrap()
          .then(() => onClose());
      }}
      actions={
        <>
          <Button
            variant="outlined"
            onClick={onClose}
            disabled={isLoading}
            startIcon={<CancelIcon />}
          >
            Avbryt
          </Button>

          <Button
            type="submit"
            variant="contained"
            color="success"
            loading={isLoading}
            startIcon={<SaveIcon />}
          >
            Spara
          </Button>
        </>
      }
    >
      <TextField
        label="Rummets namn"
        variant="filled"
        fullWidth
        required
        value={roomName}
        onChange={(e) => setRoomName(e.target.value)}
      />

      <FormControl sx={{ mt: 2 }}>
        <Typography fontSize="small">Kategorier</Typography>

        {Object.entries(Categories).map(([key, value]) => (
          <FormControlLabel
            key={key}
            label={value}
            control={
              <Checkbox
                checked={categories.includes(key as Category)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setCategories((prev) => [...prev, key as Category]);
                  } else {
                    setCategories((prev) => prev.filter((cat) => cat !== key));
                  }
                }}
              />
            }
          />
        ))}
      </FormControl>
    </LargeDialog>
  );
};

export default AddChecklistDialog;
